import { render, staticRenderFns } from "./StatusTasks.vue?vue&type=template&id=863c5c70&scoped=true"
import script from "./StatusTasks.vue?vue&type=script&lang=js"
export * from "./StatusTasks.vue?vue&type=script&lang=js"
import style0 from "./StatusTasks.vue?vue&type=style&index=0&id=863c5c70&prod&lang=css"
import style1 from "./StatusTasks.vue?vue&type=style&index=1&id=863c5c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863c5c70",
  null
  
)

export default component.exports